<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <div class="dropdown">
            <div
                :id="id"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click="showCalendarDate"
                ref="calendarTrigger"
            >
                <div class="input-group mb-1 calendar-trigger">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i :class="`fa fa-calendar fa-md`" aria-hidden="true" />
                    </span>
                    </div>
                    <span class="form-control">
                        {{ formattedDate }}
                    </span>
                </div>
            </div>
            <div
                class="dropdown-menu dropdown-menu-fixed calendar-popover"
                ref="calendarModal"
                :aria-labelledby="id"
                :class="{ show: showCalendar }"
                :style="calendarStyle"
                @click.stop
            >
                <v-date-picker
                ref="calendarPicker"
                v-model="dateValue"
                @dayclick="closeCalendar"
                :show-day-popover="false"
                :tint-color="datePickerColor"
                :available-dates="availableDates"
                show-caps
                is-inline
                ></v-date-picker>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import 'v-calendar/lib/v-calendar.min.css';

export default {
    name: 'Calendar',
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    props: {
        id:{
            type: String,
            required: true,
        },
        value:{
            type: Date,
            default: null,
        },
        label: {
            type: String,
            default: null,
            required: false,
        },
        availableDates:{
            type: Function,
            required: false,
            default: () => () => true,
        },
    },
    data() {
        return {
            dateValue: this.value,
            showCalendar: false,
            calendarStyle: {},
        };
    },
    methods: {
        showCalendarDate() {
            this.showCalendar = !this.showCalendar;
            if(this.showCalendar) {
                const trigger = this.$refs.calendarTrigger;
                const triggerRect = trigger.getBoundingClientRect();
                const modalHeight = 300;
                const viewPortHeight = window.innerHeight;
                const space = viewPortHeight - triggerRect.bottom;
                const openAbove = space < modalHeight;

                this.calendarStyle = {
                    position: 'fixed',
                    top: openAbove ? `${triggerRect.top + window.scrollY - modalHeight}px` : `${triggerRect.bottom + window.scrollY}px`,
                    left: `${triggerRect.left}px`,
                    zIndex: 9999,
                };
            }
        },
        closeCalendar(event) {
            var date = new Date(event.date);
            if(!this.availableDates(date))
                return;

            this.showCalendar = false;
            this.$emit('on-data-select', date);
        },
        handleClickOutside(event) {
            const calendar = this.$refs.calendarPicker && this.$refs.calendarPicker.$el;
            const trigger = this.$refs.calendarTrigger;
            if (calendar && !calendar.contains(event.target) && trigger && !trigger.contains(event.target)) {
                this.showCalendar = false;
            }
        },
    },
    computed: {
        formattedDate() {
            return this.dateValue ? moment(this.dateValue).format('DD/MM/YYYY') : 'Selecione uma data';
        },
        datePickerColor: function () {
            return window.localStorage.getItem('tertiaryColor') || '#FF7606';
        },
    },
    watch: {
        value: function(newVal){
            this.dateValue = newVal;
        },
    },
};
</script>

<style scoped>
.calendar-trigger {
    cursor: pointer;
}
</style>
